import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import PageShell from './PageShell/PageShell';

import Home from './Home/Home';
import First from './First/First';
import Second from './Second/Second';
import Third from './Third/Third';
import Fourth from './Fourth/Fourth';
import NoMatch from './NoMatch/NoMatch';

import './Page.css';

class Page extends Component {
  // constructor(props) {
  //   super(props);

  //   // console.log(this.props);
  // }

  render() {
    return (
      <main className="Page">
        <Switch>
          <Route exact path="/" component={PageShell(Home)} />
          <Route exact path="/first" component={PageShell(First)} />
          <Route exact path="/second" render={props => {
            return <ReactCSSTransitionGroup
              transitionAppear={true}
              transitionAppearTimeout={600}
              transitionEnterTimeout={600}
              transitionLeaveTimeout={200}
              transitionName={'FadeIn'}
            >
              <Second {...this.props} />
            </ReactCSSTransitionGroup>
          }} />
          <Route exact path="/third" component={PageShell(Third)} />
          <Route exact path="/fourth" component={PageShell(Fourth)} />
          <Route component={PageShell(NoMatch)} />
        </Switch>
      </main>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page/Page.js